module.exports = __webpack_public_path__ + "images/sam/menubaritem_submenuindicator.png";